export const GITHUB_URL = "https://github.com/jdharrison/woven";
export const DISCORD_URL = "https://discord.gg/wKjN7Gbm9n";
export const RELEASES_URL = `${GITHUB_URL}/releases/latest`;
